import { memo } from 'react';
import { TransactionsDto, useGetInvoiceDetailsQuery } from '@api/apiCompat';

import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import { Box } from '@mui/material';
import LoadingIconButton from '@components/LoadingIconButton';

const DownloadInvoiceButton = ({ row }: { row: TransactionsDto }) => {
  // If we already have a direct receipt_url, use it without an API call
  const hasDirectUrl = !!row.receipt_url;

  const { data: invoiceData, isLoading: isLoadingInvoice } = useGetInvoiceDetailsQuery(
    { id: row.invoice_id },
    { skip: hasDirectUrl || !row.invoice_id },
  );

  const receiptUrl = row.receipt_url || invoiceData?.hosted_invoice_url;

  if (!receiptUrl && !row.invoice_id) {
    return null;
  }

  return (
    <Box color="grey">
      <LoadingIconButton
        loaderSize="2rem"
        loading={!hasDirectUrl && isLoadingInvoice}
        loaderColor="secondary"
        component="a"
        // @ts-ignore
        href={receiptUrl}
        target="_blank"
        disabled={!receiptUrl}
      >
        <DownloadRoundedIcon />
      </LoadingIconButton>
    </Box>
  );
};

export default memo(DownloadInvoiceButton);
